(function () {
  'use strict';

  angular
    .module('app.category.vente-privee', ['rzModule'])

    /* @ngInject */
      .directive('isVentePrivee', ["$location", "$rootScope", "AppService", "$timeout", "$cookies", "DateService", function ($location, $rootScope, AppService, $timeout, $cookies, DateService) {
      return {
        restrict: 'A',
          link: function (scope, element) {

              scope.isVentePriveeLogged = 'hidden';
              scope.fromVentePrivee = 'false';
              

            AppService.getParams().then(function (params) {
                if (!params.IsLogged) { 
                    
                    setCookiesVP();
                    $location.path('/');                    
                    scope.isVentePriveeLogged = 'hidden';

                } else {
                    scope.isVentePriveeLogged = '';
                }
                })
                .catch(function (error) {
                    console.error(error);
                });

            scope.$on('delogUpdate', function () { 
                $location.path('/');
                scope.isVentePriveeLogged = 'hidden';
              });

            function setCookiesVP() {
                $cookies.put('cookiesVP', 'true', {
                    path: '/',
                    expires: DateService.tomorrow()
                });
            }

        }
      };
    }]);

})();
